<div>
    <h2>Nuevos arrendamientos</h2>

    <div class="chart-container">
        <p-chart height="300px" type="line" [data]="data" [options]="options"></p-chart>
    </div>
</div>